import React from 'react';
import { UiMenuDots3HIcon16Regular } from "../../../internal/icons2022/UiMenuDots3HIcon/UiMenuDots3HIcon16Regular";
import { iconSizer } from "../../../internal/icons2022/iconSizer";
export var DotsIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(UiMenuDots3HIcon16Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(UiMenuDots3HIcon16Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(UiMenuDots3HIcon16Regular, null);
  }
}, 'DotsIcon');